import React from 'react';
import { CpdsInputFieldsProps, CpdsSearchFieldsProps, CpdsInputDropDownProps, CpdsCheckboxProps } from './typings';
import Fields from './sub-input-components/fields';
import Search from './sub-input-components/search';
import Droupdown from './sub-input-components/droupdown';
import Checkbox from './sub-input-components/checkbox';

const CpdsInputs: React.FC & {
  Fields: React.FC<CpdsInputFieldsProps>;
  Search: React.FC<CpdsSearchFieldsProps>;
  Dropdown: React.FC<CpdsInputDropDownProps>;
  Checkbox: React.FC<CpdsCheckboxProps>;
} = () => {
  return null;
};

CpdsInputs.Fields = Fields;
CpdsInputs.Search = Search;
CpdsInputs.Dropdown = Droupdown;
CpdsInputs.Checkbox = Checkbox;
export { CpdsInputs };
